<template>
  <div class="login-wrap">
    <el-card class="box">
      <h2>脑智和合 · 管理端</h2>
      <el-form :model="form" @submit.native.prevent="onSubmit">
        <el-form-item label="账号">
          <el-input v-model="form.username" autocomplete="username" />
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.password" type="password" autocomplete="current-password" />
        </el-form-item>
        <el-button type="primary" native-type="submit" :loading="loading" style="width: 100%">登录</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'LoginView',
  data() {
    return {
      loading: false,
      form: { username: '', password: '' }
    };
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      try {
        await this.$store.dispatch('login', this.form);
        this.$message.success('登录成功');
        const u = this.$store.state.user;
        if (u && u.roleCode === 'CS') {
          this.$router.replace('/cs');
        } else {
          this.$router.replace('/mini-users');
        }
      } catch (e) {
        this.$message.error((e && e.message) || '登录失败');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.login-wrap {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e1f1fa 0%, #e3f7ed 100%);
}
.box {
  width: 400px;
}
.tip {
  margin-top: 16px;
  font-size: 12px;
  color: #909399;
}
</style>
